import {useLayoutEffect, useState} from 'react';
import Markdown from 'react-markdown';
import {LoadingSkeleton} from '@/components/app/feedback';
import {InfoSection} from '../../../app/components/InfoSection';
import {getConfigValue} from '../../../app/utils/configUtils';
export const TermsOfUse = () => {
  const [termsOfUse, setTermsOfUse] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>();
  useLayoutEffect(() => {
    setLoading(true);
    fetch(`${getConfigValue('landingUrl')}/assets/terms-of-use.md`)
      .then((res) => res.text())
      .then((text) => {
        setTermsOfUse(text);
        setLoading(false);
      })
      .catch((e) => {
        setError(e);
        setLoading(false);
      });
  }, []);
  return (
    <>
      {loading && renderLoading()}
      {!loading && error != null && (
        <InfoSection
          className={'h-full'}
          icon={'exclamation-triangle'}
          message={'Unexpected error occurred. Please try later.'}
          title={'Cannot Get Terms of Use'}
        />
      )}
      {!loading && error == null && <Markdown>{termsOfUse}</Markdown>}
    </>
  );
  function renderLoading() {
    return (
      <div className={'flex flex-col pt-20 gap-2 h-full'}>
        <LoadingSkeleton height={'1rem'} width={'100%'} />
        <LoadingSkeleton height={'1rem'} width={'100%'} />
        <LoadingSkeleton height={'1rem'} width={'66%'} />
        <br />
        <LoadingSkeleton height={'1rem'} width={'100%'} />
        <LoadingSkeleton height={'1rem'} width={'100%'} />
        <LoadingSkeleton height={'1rem'} width={'100%'} />
        <LoadingSkeleton height={'1rem'} width={'66%'} />
        <br />
        <LoadingSkeleton height={'1rem'} width={'100%'} />
        <LoadingSkeleton height={'1rem'} width={'100%'} />
        <LoadingSkeleton height={'1rem'} width={'66%'} />
      </div>
    );
  }
};
